/**
 * Free Gift Feature for Epigamia Shopify Store
 * v3 — Built for mm-pincode-v3-modal.liquid
 *
 * Key facts about this store:
 *  - DepotCode is stored in sessionStorage (NOT localStorage)
 *  - Pincode check hits https://pincode.epigamia.com/api/checkavailability
 *  - After pincode success, $(document).trigger('pincodeChange') fires
 *  - refactorCart() clears + rebuilds the cart asynchronously before pincodeChange fires
 *  - Cart is also rebuilt on page load via refactorCart() if DepotCode already set
 */

(function () {
  'use strict';

  var _variantCache = {};   // sku → variantId
  var _evaluating   = false;
  var _evalTimer    = null;

  /* ------------------------------------------------------------------ */
  /*  Read DepotCode — sessionStorage is primary, localStorage fallback  */
  /* ------------------------------------------------------------------ */
  function getDepotCode() {
  return sessionStorage.getItem('DepotCode') 
    || localStorage.getItem('DepotCode') 
    || sessionStorage.getItem('DepotName') 
    || localStorage.getItem('DepotName') 
    || '';
}

  /* ------------------------------------------------------------------ */
  /*  Depot → SKU (all driven by theme settings via freeGiftConfig)      */
  /* ------------------------------------------------------------------ */
  function getSkuForDepot(depotCode) {
    var cfg = window.freeGiftConfig || {};
    if (!depotCode) return cfg.sku_primary || '';

    // Depot codes as returned by the API (case-insensitive match)
    var map = {
      // Mumbai
      'kurla':              cfg.sku_mumbai    || '',
      'andheri':            cfg.sku_mumbai    || '',
      'zfwandheri':         cfg.sku_mumbai    || '',
      // Bangalore
      'bommanahalli':       cfg.sku_bangalore || '',
      'hennur':             cfg.sku_bangalore || '',
      'kalyannagar':        cfg.sku_bangalore || '',
      'zfwkalyannagar':     cfg.sku_bangalore || '',
      // Delhi
      'dwarka':             cfg.sku_delhi     || '',
      'noida':              cfg.sku_delhi     || '',
      'gurgaon':            cfg.sku_delhi     || '',
      'malviyanagar':       cfg.sku_delhi     || '',
      'zfwmalviyanagar':    cfg.sku_delhi     || '',
      // Hyderabad
      'bowenpally':         cfg.sku_hyderabad || '',
      'manikonda':          cfg.sku_hyderabad || '',
      'zfwmanikonda':       cfg.sku_hyderabad || '',
      // Chennai
      'chennai':            cfg.sku_chennai   || '',
      'zfwchennai':         cfg.sku_chennai   || '',
    };

    var lower = depotCode.toLowerCase();

    // If depot is recognised: return its SKU (empty string = no gift for this location)
    // Only fall back to primary for completely unknown depots
    if (Object.prototype.hasOwnProperty.call(map, lower)) {
      return map[lower];
    }
    return cfg.sku_primary || '';
  }


  /* ------------------------------------------------------------------ */
  /*  Resolve variant ID from SKU — cached, 3-stage fallback            */
  /* ------------------------------------------------------------------ */
  function getVariantIdBySku(sku, callback) {
    if (!sku) return callback('No SKU provided', null);
    if (_variantCache[sku]) return callback(null, _variantCache[sku]);

    // Stage 1: Predictive search
    fetch('/search/suggest.json?q=' + encodeURIComponent(sku) + '&resources[type]=product&resources[limit]=10')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (
          data.resources &&
          data.resources.results &&
          data.resources.results.products
        ) || [];

        if (!products.length) return _stage2(sku, callback);

        var checked = 0;
        var found   = false;

        products.forEach(function (p) {
          fetch('/products/' + p.handle + '.js')
            .then(function (r2) { return r2.json(); })
            .then(function (product) {
              checked++;
              if (found) return;
              for (var j = 0; j < product.variants.length; j++) {
                if (product.variants[j].sku === sku) {
                  found = true;
                  _variantCache[sku] = product.variants[j].id;
                  return callback(null, product.variants[j].id);
                }
              }
              if (checked === products.length && !found) _stage2(sku, callback);
            })
            .catch(function () {
              checked++;
              if (checked === products.length && !found) _stage2(sku, callback);
            });
        });
      })
      .catch(function () { _stage2(sku, callback); });
  }

  function _stage2(sku, callback) {
    fetch('/collections/all/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = data.products || [];
        for (var i = 0; i < products.length; i++) {
          for (var j = 0; j < products[i].variants.length; j++) {
            if (products[i].variants[j].sku === sku) {
              _variantCache[sku] = products[i].variants[j].id;
              return callback(null, products[i].variants[j].id);
            }
          }
        }
        _stage3(sku, callback);
      })
      .catch(function () { _stage3(sku, callback); });
  }

  function _stage3(sku, callback) {
    fetch('/products.json?limit=250&page=1')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = data.products || [];
        for (var i = 0; i < products.length; i++) {
          for (var j = 0; j < products[i].variants.length; j++) {
            if (products[i].variants[j].sku === sku) {
              _variantCache[sku] = products[i].variants[j].id;
              return callback(null, products[i].variants[j].id);
            }
          }
        }
        callback('SKU not found in store: ' + sku, null);
      })
      .catch(function (err) { callback(err, null); });
  }

  /* ------------------------------------------------------------------ */
  /*  Cart helpers                                                       */
  /* ------------------------------------------------------------------ */
  function getCart(cb) {
    fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { cb(null, cart); })
      .catch(function (err) { cb(err, null); });
  }

  // Identify gift items by SKU — no line item properties needed
  function isGiftSku(sku) {
    var cfg = window.freeGiftConfig || {};
    var giftSkus = [
      cfg.sku_primary, cfg.sku_mumbai, cfg.sku_bangalore,
      cfg.sku_hyderabad, cfg.sku_delhi, cfg.sku_chennai
    ].filter(Boolean);
    return !!(sku && giftSkus.indexOf(sku) !== -1);
  }

  function findFreeGiftItem(cart) {
    if (!cart || !cart.items) return null;
    for (var i = 0; i < cart.items.length; i++) {
      if (isGiftSku(cart.items[i].sku)) return cart.items[i];
    }
    return null;
  }

  function addFreeGift(variantId, cb) {
    window._freeGiftAdding = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }]  // no properties = clean admin order view
      })
    })
    .then(function (r) { return r.json(); })
    .then(function (d) { window._freeGiftAdding = false; cb(null, d); })
    .catch(function (e) { window._freeGiftAdding = false; cb(e, null); });
  }

  function removeFreeGift(lineKey, cb) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    })
    .then(function (r) { return r.json(); })
    .then(function (d) { cb(null, d); })
    .catch(function (e) { cb(e, null); });
  }

  function rerenderCart() {
    if (typeof mmajaxcart !== 'undefined' && mmajaxcart.AjaxcartRender) {
      mmajaxcart.AjaxcartRender();
    }
    // Update cart count badges
    getCart(function (err, cart) {
      if (err || !cart) return;
      document.querySelectorAll('[data-cart-count-ajax]').forEach(function (el) {
        el.textContent = cart.item_count;
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /*  Core evaluation — should free gift be in cart?                     */
  /* ------------------------------------------------------------------ */
  function evaluateFreeGift(source) {
    var cfg = window.freeGiftConfig || {};
    if (!cfg.enabled) return;

    if (_evaluating) {
      console.log('[FreeGift] Skipping — already evaluating');
      return;
    }
    _evaluating = true;

    var depotCode = getDepotCode();
    var sku       = getSkuForDepot(depotCode);
    var minValue  = parseFloat(cfg.min_cart_value) || 0;

    console.log('[FreeGift] Evaluating | source:', source, '| depot:', depotCode, '| sku:', sku, '| minValue:', minValue);

    getCart(function (err, cart) {
      if (err || !cart) {
        _evaluating = false;
        return;
      }

      // Total of paid (non-gift) items
      var cartTotal = 0;
      cart.items.forEach(function (item) {
        if (!isGiftSku(item.sku)) {
          cartTotal += item.final_line_price / 100;
        }
      });

      var existingGift   = findFreeGiftItem(cart);
      // Gift only added when there are paid items AND threshold is met
      var shouldHaveGift = (cartTotal > 0) && ((minValue === 0) || (cartTotal >= minValue));

      console.log('[FreeGift] cartTotal:', cartTotal, '| shouldHaveGift:', shouldHaveGift, '| existingGift:', !!existingGift);

      if (shouldHaveGift && sku) {
        // Need a gift — resolve the variant ID first
        getVariantIdBySku(sku, function (skuErr, variantId) {
          if (skuErr || !variantId) {
            console.warn('[FreeGift] Could not resolve variant for SKU:', sku, '|', skuErr);
            _evaluating = false;
            return;
          }

          console.log('[FreeGift] variantId resolved:', variantId);

          // Correct gift already present
          if (existingGift && existingGift.variant_id === variantId) {
            console.log('[FreeGift] Correct gift already in cart — nothing to do.');
            _evaluating = false;
            updateBanner();
            return;
          }

          // Wrong variant (depot changed) — swap it
          if (existingGift && existingGift.variant_id !== variantId) {
            console.log('[FreeGift] Swapping gift to correct depot variant...');
            removeFreeGift(existingGift.key, function () {
              addFreeGift(variantId, function () {
                _evaluating = false;
                rerenderCart();
                updateBanner();
              });
            });
            return;
          }

          // No gift yet — add it
          console.log('[FreeGift] Adding free gift...');
          addFreeGift(variantId, function (addErr) {
            if (addErr) console.warn('[FreeGift] Add failed:', addErr);
            _evaluating = false;
            rerenderCart();
            updateBanner();
          });
        });

      } else {
        // Should NOT have gift — remove if present
        if (existingGift) {
          console.log('[FreeGift] Removing gift (below threshold)...');
          removeFreeGift(existingGift.key, function () {
            _evaluating = false;
            rerenderCart();
            updateBanner();
          });
        } else {
          _evaluating = false;
          updateBanner();
        }
      }
    });
  }

  // Debounced schedule — resets the lock before running
  function scheduleEval(delay, source) {
    clearTimeout(_evalTimer);
    _evalTimer = setTimeout(function () {
      _evaluating = false;
      evaluateFreeGift(source);
    }, delay || 800);
  }

  /* ------------------------------------------------------------------ */
  /*  Banner UI in cart drawer                                           */
  /* ------------------------------------------------------------------ */
  function updateBanner() {
    var cfg      = window.freeGiftConfig || {};
    var minValue = parseFloat(cfg.min_cart_value) || 0;
    if (!cfg.enabled || minValue === 0) return;

    // No gift configured for this location — hide banner and stop
    var sku = getSkuForDepot(getDepotCode());
    if (!sku) {
      var existing = document.querySelector('.mm-free-gift-banner');
      if (existing) existing.style.display = 'none';
      return;
    }

    getCart(function (err, cart) {
      if (err || !cart) return;

      var nonGiftTotal = 0;
      cart.items.forEach(function (item) {
        if (!isGiftSku(item.sku)) {
          nonGiftTotal += item.final_line_price / 100;
        }
      });

      // Find or create banner element
      var banner    = document.querySelector('.mm-free-gift-banner');
      var cartBody  = document.querySelector('.mm-ajaxcart-body');
      if (!cartBody) return;

      if (!banner) {
        banner = document.createElement('div');
        banner.className = 'mm-free-gift-banner';
        var bar = cartBody.querySelector('.shipping_progress_bar');
        if (bar) {
          bar.insertAdjacentElement('afterend', banner);
        } else {
          cartBody.insertAdjacentElement('afterbegin', banner);
        }
      }

      if (nonGiftTotal >= minValue) {
        banner.className = 'mm-free-gift-banner mm-free-gift-banner--unlocked';
        banner.innerHTML =
          '<span class="mm-free-gift-icon">🎁</span>' +
          '<span>' + (cfg.reached_message || "You've unlocked a FREE gift!") + '</span>';
      } else {
        var remaining = Math.ceil(minValue - nonGiftTotal);
        var msg = (cfg.banner_message || 'Add [remaining] more to unlock a FREE gift!')
          .replace('[remaining]', '₹' + remaining);
        banner.className = 'mm-free-gift-banner mm-free-gift-banner--locked';
        banner.innerHTML =
          '<span class="mm-free-gift-icon">🎁</span>' +
          '<span>' + msg + '</span>';
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /*  Mark free gift visually in cart drawer DOM                         */
  /* ------------------------------------------------------------------ */
  function markFreeGiftInDOM() {
    var cfg       = window.freeGiftConfig || {};
    var badgeText = cfg.badge_text || '🎁 FREE GIFT';

    getCart(function (err, cart) {
      if (err || !cart) return;

      // Build a set of free-gift variant IDs (identified by SKU)
      var freeGiftVariantIds = {};
      cart.items.forEach(function (item) {
        if (isGiftSku(item.sku)) {
          freeGiftVariantIds[item.variant_id] = true;
        }
      });

      if (!Object.keys(freeGiftVariantIds).length) return;

      // Match DOM items to cart items by position
      var domItems = document.querySelectorAll('.mm-ajaxcart-item.CartItem');
      cart.items.forEach(function (cartItem, idx) {
        if (!freeGiftVariantIds[cartItem.variant_id]) return;

        var domItem = domItems[idx];
        if (!domItem) return;

        domItem.classList.add('mm-ajaxcart-item--free-gift');

        // Badge — insert once
        if (!domItem.querySelector('.mm-free-gift-badge')) {
          var badge       = document.createElement('div');
          badge.className   = 'mm-free-gift-badge';
          badge.textContent = badgeText;
          var header = domItem.querySelector('.mm-ajaxcart-info-header');
          if (header) header.insertAdjacentElement('beforebegin', badge);
        }

        // Override price to show FREE
        var priceEl = domItem.querySelector('.mm-ajaxcart-item-price');
        if (priceEl && !priceEl.querySelector('.free-gift-price')) {
          priceEl.innerHTML = '<span class="free-gift-price">FREE</span>';
        }

        // Hide quantity controls — customer cannot remove free gift
        var qtyEl = domItem.querySelector('.mm-ajaxcart-item-quantity');
        if (qtyEl) qtyEl.style.display = 'none';
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /*  Patch mmajaxcart.AjaxcartRender + observe cart drawer             */
  /* ------------------------------------------------------------------ */
  function patchAndObserveCart() {
    // Patch render — wait for mmajaxcart to be available
    (function tryPatch(attempts) {
      if (typeof mmajaxcart !== 'undefined' && mmajaxcart.AjaxcartRender) {
        var orig = mmajaxcart.AjaxcartRender.bind(mmajaxcart);
        mmajaxcart.AjaxcartRender = function () {
          orig();
          setTimeout(markFreeGiftInDOM, 350);
          setTimeout(updateBanner, 450);
        };
        console.log('[FreeGift] Patched mmajaxcart.AjaxcartRender');
      } else if (attempts > 0) {
        setTimeout(function () { tryPatch(attempts - 1); }, 300);
      }
    }(30));

    // MutationObserver on the cart items list
    (function tryObserve(attempts) {
      var target = document.querySelector('.mm-ajaxcart-items, [class*="ajaxcart-items"]');
      if (target) {
        new MutationObserver(function () {
          setTimeout(markFreeGiftInDOM, 300);
          setTimeout(updateBanner, 400);
        }).observe(target, { childList: true, subtree: true });
        console.log('[FreeGift] Observing cart items list');
      } else if (attempts > 0) {
        setTimeout(function () { tryObserve(attempts - 1); }, 400);
      }
    }(20));
  }

  /* ------------------------------------------------------------------ */
  /*  Event binding                                                      */
  /* ------------------------------------------------------------------ */
  function bindEvents() {

    // ── 1. pincodeChange — fired by jQuery at end of ValidatePincode ──
    //    refactorCart() has already run and page may have reloaded,
    //    but in the non-page-load path the cart is ready by this point.
    //    We use a longer delay (1200ms) to let refactorCart settle.
    document.addEventListener('pincodeChange', function () {
      console.log('[FreeGift] pincodeChange event');
      scheduleEval(1200, 'pincodeChange');
    });

    // ── 2. Watch data-pincode-success panel becoming visible ──────────
    //    This fires even before pincodeChange in the success path.
    (function watchSuccessPanel() {
      function attachObserver(panel) {
        new MutationObserver(function () {
          if (panel.style.display !== 'none' && panel.style.display !== '') {
            console.log('[FreeGift] Pincode success panel visible');
            scheduleEval(1500, 'pincode-success-panel');
          }
        }).observe(panel, { attributes: true, attributeFilter: ['style'] });
      }

      var panel = document.querySelector('[data-pincode-success]');
      if (panel) {
        attachObserver(panel);
      } else {
        new MutationObserver(function (_, obs) {
          var p = document.querySelector('[data-pincode-success]');
          if (p) { obs.disconnect(); attachObserver(p); }
        }).observe(document.body, { childList: true, subtree: true });
      }
    }());

    // ── 3. Intercept XHR — catches jQuery $.ajax used by the store ────
    //    IMPORTANT: we must NOT intercept /cart/clear.js triggered by
    //    refactorCart, or we'd add the gift before the cart is rebuilt.
    //    We guard with a flag set during refactorCart.
    var _xhrOpen = XMLHttpRequest.prototype.open;
    var _xhrSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this._fgUrl = String(url);
      return _xhrOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      var url  = this._fgUrl || '';
      var self = this;

      // Only trigger evaluation on add (not on clear/change from refactorCart)
      if (url.indexOf('/cart/add') !== -1) {
        this.addEventListener('load', function () {
          if (window._freeGiftRefactoring) return;
          scheduleEval(900, 'xhr:' + url);
        });
      }
      // Trigger on clear.js only if not part of refactorCart
      if (url.indexOf('/cart/clear') !== -1 || url.indexOf('/cart/change') !== -1) {
        this.addEventListener('load', function () {
          if (window._freeGiftRefactoring) return;
          scheduleEval(1000, 'xhr:' + url);
        });
      }
      return _xhrSend.apply(this, arguments);
    };

    // ── 4. Intercept fetch — catches native fetch cart operations ─────
    var _origFetch = window.fetch;
    window.fetch = function (input, opts) {
      var url    = typeof input === 'string' ? input : (input && input.url) || '';
      var isSelf = !!window._freeGiftAdding;  // our own add-to-cart request
      var result = _origFetch.apply(this, arguments);

      if (!isSelf && !window._freeGiftRefactoring) {
        if (/\/cart\/(add|change|clear)/.test(url)) {
          result.then(function () {
            scheduleEval(1000, 'fetch:' + url);
          }).catch(function () {});
        }
      }
      return result;
    };

    // ── 5. Quantity +/- buttons ───────────────────────────────────────
    document.addEventListener('click', function (e) {
      if (e.target.closest('.quantity-minus, .quantity-plus')) {
        scheduleEval(1200, 'qty-btn');
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /*  Wrap refactorCart to set a flag so we don't add gift mid-rebuild   */
  /* ------------------------------------------------------------------ */
  function wrapRefactorCart() {
    // refactorCart is defined in mm-pincode-v3-modal.liquid as a global async fn
    (function tryWrap(attempts) {
      if (typeof window.refactorCart === 'function') {
        var _origRefactor = window.refactorCart;
        window.refactorCart = async function () {
          window._freeGiftRefactoring = true;
          console.log('[FreeGift] refactorCart started — pausing gift evaluation');
          try {
            await _origRefactor.apply(this, arguments);
          } finally {
            window._freeGiftRefactoring = false;
            console.log('[FreeGift] refactorCart done — scheduling gift evaluation');
            // After refactorCart finishes (cart rebuilt), evaluate
            scheduleEval(1500, 'post-refactorCart');
          }
        };
        console.log('[FreeGift] Wrapped refactorCart');
      } else if (attempts > 0) {
        setTimeout(function () { tryWrap(attempts - 1); }, 200);
      }
    }(30));
  }

  /* ------------------------------------------------------------------ */
  /*  Inject CSS                                                         */
  /* ------------------------------------------------------------------ */
  function injectStyles() {
    var style = document.createElement('style');
    style.textContent = [
      /* Banner */
      '.mm-free-gift-banner{',
      '  display:flex;align-items:center;gap:8px;',
      '  padding:10px 16px;margin:8px 12px;border-radius:6px;',
      '  font-size:13px;font-weight:600;',
      '}',
      '.mm-free-gift-banner--locked{',
      '  background:#fff8f0;border:1.5px dashed #CA7077;color:#CA7077;',
      '}',
      '.mm-free-gift-banner--unlocked{',
      '  background:#f0fff4;border:1.5px solid #2C8F16;color:#2C8F16;',
      '}',
      '.mm-free-gift-icon{ font-size:18px; flex-shrink:0; }',
      /* Cart item */
      '.mm-free-gift-badge{',
      '  display:inline-block;background:#CA7077;color:#fff;',
      '  font-size:10px;font-weight:700;padding:2px 8px;',
      '  border-radius:20px;margin-bottom:4px;',
      '  letter-spacing:.5px;text-transform:uppercase;',
      '}',
      '.mm-ajaxcart-item--free-gift .free-gift-price{',
      '  color:#2C8F16;font-weight:700;',
      '}',
      '.mm-ajaxcart-item--free-gift .mm-ajaxcart-item-quantity{ display:none !important; }',
      '.mm-ajaxcart-item--free-gift .compare--price{ display:none !important; }',
    ].join('\n');
    document.head.appendChild(style);
  }

  /* ------------------------------------------------------------------ */
  /*  Pre-warm SKU cache on load                                         */
  /* ------------------------------------------------------------------ */
  function prewarmSkuCache() {
    var cfg = window.freeGiftConfig || {};
    var skus = [
      cfg.sku_primary,
      cfg.sku_mumbai,
      cfg.sku_bangalore,
      cfg.sku_hyderabad,
      cfg.sku_delhi,
      cfg.sku_chennai
    ].filter(Boolean).filter(function (v, i, a) { return a.indexOf(v) === i; });

    skus.forEach(function (sku) {
      getVariantIdBySku(sku, function (err, id) {
        if (!err && id) {
          console.log('[FreeGift] Pre-warmed SKU:', sku, '→ variantId:', id);
        } else {
          console.warn('[FreeGift] SKU pre-warm failed:', sku, err);
        }
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /*  Bootstrap                                                          */
  /* ------------------------------------------------------------------ */
  function init() {
    var cfg = window.freeGiftConfig || {};
    if (!cfg.enabled) {
      console.log('[FreeGift] Feature disabled — skipping init.');
      return;
    }

    console.log('[FreeGift] Init v3 | config:', JSON.stringify(cfg));

    injectStyles();
    wrapRefactorCart();   // Must run before events are bound
    bindEvents();
    patchAndObserveCart();
    prewarmSkuCache();

    // If DepotCode already set (returning visitor / same session),
    // evaluate after a short delay to let the page + cart settle.
    // The page-load refactorCart() will also trigger a post-refactorCart eval.
    if (getDepotCode()) {
      scheduleEval(2000, 'init-returning-visitor');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

}());
